module.exports = __webpack_public_path__ + "static/media/filename (23).ae882e4c.png";